import React from "react";

const SmileCard = ({
  label,
  imageSrc,
  imageAlt,
  isAfter = false,
  className = "",
  mobile = false,
}) => {
  const floatClass = isAfter ? "animate-float-after" : "animate-float-before";

  if (mobile) {
    return (
      <div className={className}>
        <div
          className={`absolute -top-6 left-1/2 -translate-x-1/2 rounded-full bg-blue-100 text-[#0066ff] px-3 py-0.5 text-xs font-bold shadow-xl shadow-blue-500/30 z-10 whitespace-nowrap ${isAfter ? "rotate-6" : "-rotate-6"}`}
        >
          {label}
        </div>
        <div
          className={`p-2 bg-white/70 backdrop-blur-md rounded-[24px] shadow-2xl ${floatClass} border ${isAfter ? "border-blue-200/70" : "border-blue-100/50"}`}
        >
          {isAfter ? (
            <div className="bg-blue-500 rounded-[20px] p-0.5">
              <img
                src={imageSrc}
                alt={imageAlt}
                width="200"
                height="200"
                className="rounded-[19px] w-[200px] h-[200px] object-cover"
              />
            </div>
          ) : (
            <img
              src={imageSrc}
              alt={imageAlt}
              width="160"
              height="180"
              className="rounded-[18px] w-[160px] h-[180px] object-cover"
            />
          )}
        </div>
      </div>
    );
  }

  // Desktop layout
  return (
    <div
      className={`relative z-10 scale-90 lg:scale-110 origin-center ${className}`}
    >
      <div
        className={`absolute -top-16 left-1/2 -translate-x-1/2 bg-[#e6f0ff] text-[#0066ff] px-6 py-1.5 rounded-full text-lg font-bold shadow-lg border border-white/50 z-30 whitespace-nowrap ${isAfter ? "rotate-[6deg]" : "-rotate-[6deg]"}`}
      >
        {label}
      </div>
      <div
        className={`p-3 bg-white/40 backdrop-blur-md rounded-[32px] shadow-2xl ${floatClass} border border-blue-100/50`}
      >
        {isAfter ? (
          <div className="bg-blue-500 rounded-[24px] p-0.5">
            <img
              src={imageSrc}
              alt={imageAlt}
              width="280"
              height="350"
              className="rounded-[23px] w-full max-w-[280px] lg:max-w-[246px] aspect-[4/5] object-cover"
            />
          </div>
        ) : (
          <img
            src={imageSrc}
            alt={imageAlt}
            width="280"
            height="350"
            className="rounded-[24px] w-full max-w-[280px] lg:max-w-[246px] aspect-[4/5] object-cover"
          />
        )}
      </div>
    </div>
  );
};

export default SmileCard;
